/** @format */

import { makeStyles } from '@material-ui/core';
import React from 'react';
import adescomStyle from '../../../../assets/jss/adescom/adescomStyle';
import SimpleSelectRest from '../../../../components/Adescom/SimpleSelectRest';
import CustomInputExtNumber from '../../../../components/CustomInput/CustomInputExtNumber';
import InputFormRest from '../../../../components/Form/InputFormRest';
import GridContainer from '../../../../components/Grid/GridContainer';
import GridItem from '../../../../components/Grid/GridItem';
import { FormGeneralHelper } from '../../../../helpers/FormGeneral';
import RateSchemaInterface from '../../../../interfaces/billing/RateSchemaInterface';

interface RateCallProps {
    changeRateInput: (e: any, stateName: string) => void;
    changeRateSelect: (e: any, stateName: string) => void;
    rateEntity: RateSchemaInterface;
    rateEntityStatus: any;
}

export const RateCall = (props: RateCallProps): React.ReactElement => {
    const useStyle = makeStyles(adescomStyle);
    const classes = useStyle();

    const { rateEntity, rateEntityStatus, changeRateInput, changeRateSelect } = props;

    const typeCollections = {
        'hydra:member': [
            { name: 'pricelists:collections.time', value: 2 },
            { name: 'pricelists:collections.one_time', value: 1 },
            { name: 'pricelists:collections.free', value: 0 },
        ],
    };

    const countingCollection = {
        'hydra:member': [
            { name: 'pricelists:collections.one', value: 1 },
            { name: 'pricelists:collections.three', value: 3 },
            { name: 'pricelists:collections.six', value: 6 },
        ],
    };

    return (
        <GridContainer>
            <GridItem xs={12}>
                <GridContainer spacing={0}>
                    <GridItem xs={12}>
                        <SimpleSelectRest
                            callback={changeRateSelect}
                            restElements={typeCollections}
                            stateName="type"
                            idState="type"
                            idSelected={rateEntity.type}
                            propKey="value"
                            required={false}
                            propValue="name"
                            emptyLabel="general:common.empty_label"
                            label="pricelists:h.type"
                        />
                    </GridItem>
                    {rateEntity.type === 2 && (
                        <GridItem xs={12}>
                            <SimpleSelectRest
                                callback={changeRateSelect}
                                restElements={countingCollection}
                                stateName="countingUnit"
                                idState="countingUnit"
                                idSelected={rateEntity.countingUnit}
                                propKey="value"
                                required={false}
                                propValue="name"
                                emptyLabel="general:common.empty_label"
                                label="pricelists:h.counting_unit"
                            />
                            <GridContainer spacing={0}>
                                <GridItem xs={5}>
                                    <InputFormRest
                                        classes={classes}
                                        callback={changeRateInput}
                                        stateName="interval1"
                                        stateObjectState={rateEntityStatus.interval1}
                                        typeCallback={FormGeneralHelper.TYPE_TEXT}
                                        typeField={FormGeneralHelper.TYPE_TEXT}
                                        displayFieldName="pricelists:h.interval1"
                                        required={false}
                                        vMax={255}
                                        vMin={0}
                                        value={rateEntity.interval1}
                                    />
                                    <CustomInputExtNumber
                                        formControlProps={{ fullWidth: true }}
                                        required={true}
                                        labelText="pricelists:h.price1"
                                        name="price1"
                                        value={rateEntity.price1}
                                        decimalLimit={10}
                                        onChange={changeRateInput}
                                    />
                                    <InputFormRest
                                        classes={classes}
                                        callback={changeRateInput}
                                        stateName="duration1"
                                        stateObjectState={rateEntityStatus.duration1}
                                        typeCallback={FormGeneralHelper.TYPE_TEXT}
                                        typeField={FormGeneralHelper.TYPE_TEXT}
                                        displayFieldName="pricelists:h.duration1"
                                        required={false}
                                        vMax={255}
                                        vMin={0}
                                        value={rateEntity.duration1}
                                    />
                                </GridItem>
                                <GridItem xs={2}></GridItem>
                                <GridItem xs={5}>
                                    <InputFormRest
                                        classes={classes}
                                        callback={changeRateInput}
                                        stateName="interval2"
                                        stateObjectState={rateEntityStatus.interval2}
                                        typeCallback={FormGeneralHelper.TYPE_TEXT}
                                        typeField={FormGeneralHelper.TYPE_TEXT}
                                        displayFieldName="pricelists:h.interval2"
                                        required={false}
                                        vMax={255}
                                        vMin={0}
                                        value={rateEntity.interval2}
                                    />
                                    <CustomInputExtNumber
                                        onChange={changeRateInput}
                                        name="price2"
                                        labelText="pricelists:h.price2"
                                        required={false}
                                        formControlProps={{ fullWidth: true }}
                                        value={rateEntity.price2}
                                        decimalLimit={10}
                                    />
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    )}
                    {(rateEntity.type === 2 || rateEntity.type === 1) && (
                        <GridItem xs={12}>
                            <CustomInputExtNumber
                                onChange={changeRateInput}
                                name="initial"
                                labelText="pricelists:h.initial_price"
                                required={true}
                                value={rateEntity.initial}
                                decimalLimit={10}
                            />
                        </GridItem>
                    )}
                </GridContainer>
            </GridItem>
        </GridContainer>
    );
};
